import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './Producers.css';
import Modal from 'react-modal';
import SiteNavBar from './navigation/SiteNavBar';
import { config } from '../../config';

const ADMIN_EMAIL = 'team@farmersmarketspace.com'; // Replace with your admin email or fetch from settings
const API_BASE = config.API_BASE;

const Producers = () => {
  const [producers, setProducers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedProducer, setSelectedProducer] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    const fetchProducers = async () => {
      try {
        const res = await axios.get(`${API_BASE}/api/producers`);
        setProducers(res.data);
      } catch (err) {
        setError('Failed to load producers.');
      } finally {
        setLoading(false);
      }
    };
    fetchProducers();
  }, []);

  if (loading) return <div style={{textAlign:'center', marginTop:40}}>Loading producers...</div>;
  if (error) return <div style={{textAlign:'center', marginTop:40, color:'red'}}>{error}</div>;

  return (
    <div>
      <SiteNavBar />
      <div className="producers-container">
        <h1 className="producers-title">Meet Our Producers</h1>
        <div style={{display:'flex', flexWrap:'wrap', justifyContent:'center', gap:32}}>
          {producers.map(producer => (
            <div key={producer._id} className="producer-card" onClick={() => { setSelectedProducer(producer); setModalOpen(true); }} style={{ cursor: 'pointer' }}>
              <img src={producer.logo || '/default-producer.png'} alt={producer.farmName} />
              <h2>{producer.farmName}</h2>
              <div className="producer-location">{producer.address?.city}, {producer.address?.state}</div>
              <div className="producer-description">{producer.description || 'No description available.'}</div>
              <div className="producer-actions">
                {producer.showConnect !== false && (
                  <a
                    href={`mailto:${ADMIN_EMAIL}?subject=Connect with Producer`}
                    style={{
                      background: '#007bff',
                      color: '#fff',
                      padding: '8px 16px',
                      borderRadius: 8,
                      textDecoration: 'none',
                      fontWeight: 'bold'
                    }}
                  >
                    Connect
                  </a>
                )}
                {producer.showScheduleVisit !== false && (
                  <a
                    href={`mailto:${ADMIN_EMAIL}?subject=Schedule Visit`}
                    style={{
                      background: '#28a745',
                      color: '#fff',
                      padding: '8px 16px',
                      borderRadius: 8,
                      textDecoration: 'none',
                      fontWeight: 'bold'
                    }}
                  >
                    Schedule Visit
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
        <Modal
          isOpen={modalOpen}
          onRequestClose={() => setModalOpen(false)}
          contentLabel="Producer Details"
          ariaHideApp={false}
          style={{ 
            overlay: {
              zIndex: 9999,
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              paddingTop: '120px'
            },
            content: { 
              maxWidth: 900, 
              maxHeight: 'calc(90vh - 140px)',
              margin: 'auto', 
              borderRadius: 16, 
              padding: 0,
              overflow: 'auto',
              zIndex: 10000,
              position: 'relative',
              top: 0
            } 
          }}
        >
          {selectedProducer && (
            <div style={{ display: 'flex', flexDirection: 'row', minHeight: 400, position: 'relative' }}>
              <button 
                onClick={() => setModalOpen(false)} 
                style={{ 
                  position: 'absolute', 
                  top: 16, 
                  right: 16, 
                  fontSize: 24, 
                  background: 'none', 
                  border: 'none', 
                  cursor: 'pointer',
                  zIndex: 10001
                }}
              >
                &times;
              </button>
              <div style={{ flex: 1, background: '#fafafa', padding: 24, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <img src={selectedProducer.logo || '/default-producer.png'} alt={selectedProducer.farmName} style={{ width: 140, height: 140, borderRadius: '50%', objectFit: 'cover', marginBottom: 16, border: '2px solid #eee' }} />
                <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 16 }}>
                  {selectedProducer.gallery && selectedProducer.gallery.map((img, idx) => (
                    <img key={idx} src={img} alt="Gallery" style={{ width: 80, height: 80, borderRadius: 8, objectFit: 'cover' }} />
                  ))}
                </div>
              </div>
              <div style={{ flex: 2, padding: 32, background: '#fff', minHeight: 400, overflow: 'auto' }}>
                <h2 style={{ marginBottom: 8, wordWrap: 'break-word', overflowWrap: 'break-word' }}>{selectedProducer.farmName}</h2>
                <div style={{ color: '#888', marginBottom: 8, wordWrap: 'break-word' }}>{selectedProducer.address?.city}, {selectedProducer.address?.state}</div>
                <div style={{ marginBottom: 8 }}><b>Contact:</b> {selectedProducer.name || selectedProducer.contactName || 'N/A'}</div>
                <div style={{ marginBottom: 8 }}><b>Address:</b> {selectedProducer.address?.street}, {selectedProducer.address?.city}, {selectedProducer.address?.state} {selectedProducer.address?.zip}</div>
                <div style={{ marginBottom: 16 }}><b>Phone:</b> {selectedProducer.contactNumber || 'N/A'}</div>
                <div style={{ marginBottom: 16, wordWrap: 'break-word', overflowWrap: 'break-word' }}><b>About Us:</b><br />{selectedProducer.aboutUs || selectedProducer.description || 'No about us info.'}</div>
                <div style={{ marginBottom: 16, wordWrap: 'break-word', overflowWrap: 'break-word' }}><b>Practices:</b><br />{selectedProducer.practices || 'No practices info.'}</div>
                <div style={{ display: 'flex', gap: 12, marginTop: 16 }}>
                  {selectedProducer.showConnect !== false && (
                    <a
                      href={`mailto:${ADMIN_EMAIL}?subject=Connect with Producer`}
                      style={{
                        background: '#007bff',
                        color: '#fff',
                        padding: '8px 16px',
                        borderRadius: 8,
                        textDecoration: 'none',
                        fontWeight: 'bold'
                      }}
                    >
                      Connect
                    </a>
                  )}
                  {selectedProducer.showScheduleVisit !== false && (
                    <a
                      href={`mailto:${ADMIN_EMAIL}?subject=Schedule Visit`}
                      style={{
                        background: '#28a745',
                        color: '#fff',
                        padding: '8px 16px',
                        borderRadius: 8,
                        textDecoration: 'none',
                        fontWeight: 'bold'
                      }}
                    >
                      Schedule Visit
                    </a>
                  )}
                </div>
              </div>
            </div>
          )}
        </Modal>
      </div>
    </div>
  );
};

export default Producers; 